import { GENERAL_ACTION } from "./types";

export const updateHeaderConfig = headerConfig => {
  return {
    type: GENERAL_ACTION.UPDATE_HEADER_CONFIG,
    payload: { headerConfig }
  };
};

export const clearError = () => {
  return {
    type: GENERAL_ACTION.CLEAR_ERROR
  };
};

export const clearSuccess = () => {
  return {
    type: GENERAL_ACTION.CLEAR_SUCCESS
  };
};

export const showError = error => {
  return dispatch => {
    dispatch({
      type: GENERAL_ACTION.SHOW_ERROR,
      payload: { error }
    });
  };
};

export const showSuccess = success => {
  return dispatch => {
    dispatch({
      type: GENERAL_ACTION.SHOW_SUCCESS,
      payload: { success }
    });
  };
};



// WEBPACK FOOTER //
// ./src/modules/Layout/actions/generalAction.js